import * as React from "react";
import type { SVGProps } from "react";
const SvgEarphoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="earphone_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M258.56 247.637c34.304-43.818 102.57-76.97 253.44-76.97 150.912 0 219.179 33.152 253.44 76.97 33.195 42.496 43.477 105.216 45.013 195.2A128.043 128.043 0 0 0 682.667 570.88v95.573a128 128 0 0 0 84.181 120.32c-1.963 14.336-6.144 23.168-10.752 29.099-6.4 8.277-18.005 16.512-41.13 23.04-23.467 6.699-54.955 10.496-96.854 12.459-41.643 1.962-90.71 1.962-148.779 1.962a42.667 42.667 0 1 0 0 85.334h.854c57.045 0 108.074 0 151.893-2.048 43.776-2.048 83.157-6.23 116.181-15.574 33.366-9.429 63.787-25.173 85.248-52.906 17.878-23.04 26.582-50.475 29.056-80.768a128 128 0 0 0 86.102-120.918V570.88c0-37.717-16.427-72.107-43.094-95.744.299-1.92.427-3.84.427-5.803 0-101.888-6.656-201.728-63.36-274.261C773.76 119.765 671.36 85.333 512 85.333c-159.403 0-261.803 34.432-320.64 109.739C134.656 267.605 128 367.445 128 469.333c0 1.963.128 3.926.427 5.803a127.915 127.915 0 0 0-43.094 95.787v95.53a128 128 0 0 0 256 0V570.88a128.043 128.043 0 0 0-127.786-128c1.536-90.027 11.818-152.747 45.056-195.243zM256 570.88v95.53a42.667 42.667 0 0 1-85.333 0v-95.573a42.667 42.667 0 1 1 85.333 0zm562.005 137.515A42.667 42.667 0 0 1 768 666.453V570.88a42.667 42.667 0 0 1 85.333 0v95.573a42.667 42.667 0 0 1-35.328 41.984z"
    />
  </svg>
);
export default SvgEarphoneIcon;
